export const errorMessages = {
    ACCOUNT_LOCKED: {
        text: 'Your account has been locked. Please contact <a href="%(link)s" target="_blank">customer service</a> to regain access.',
        url: 'https://www.eventbrite.com/help/en-us/',
    },
    ACCOUNT_SUSPENDED: {
        text: 'Your account has been suspended. Please contact <a href="%(link)s" target="_blank">customer service</a> for additional details.',
        url: 'https://www.eventbrite.com/help/en-us/',
    },
    CONFIRM_EMAIL: {
        text: 'Let’s confirm your email first. Check your email for a link to log in.',
        url: '',
    },
    ADD_EMAIL_TO_FACEBOOK: {
        text: 'It looks like you don’t have an email address connected to your Facebook account. You’ll need to add one before logging in to Eventbrite with Facebook. <a href="%(link)s" target="_blank">Learn how</a>',
        url: 'https://www.facebook.com/help/162801153783275',
    },
    ADD_EMAIL_TO_APPLE: {
        text: 'It looks like you don’t have an email address connected to your Apple account. You’ll need to add one before logging in to Eventbrite with Apple. <a href="%(link)s" target="_blank">Learn how</a>',
        url: 'https://support.apple.com/en-us/102619',
    },
    SOMETHING_WENT_WRONG: {
        text: 'Something went wrong. Please try again.',
        url: '',
    },
    SOCIAL_LOGIN_DENIED: {
        text: 'Social login is not available for Eventbrite accounts. Please use your email and password to log in instead.',
        url: '',
    },
    ACCOUNT_NOT_LINKED_FACEBOOK: {
        text: 'Your Facebook account hasn’t been linked to Eventbrite yet. Log in with your email and password first, then you can link your accounts by going to your Account Settings.',
        url: '',
    },
    ACCOUNT_NOT_LINKED_GOOGLE: {
        text: 'Your Google account hasn’t been linked to Eventbrite yet. Log in with your email and password first, then you can link your accounts by going to your Account Settings.',
        url: '',
    },
    ACCOUNT_NOT_LINKED_APPLE: {
        text: 'Your Apple account hasn’t been linked to Eventbrite yet. Log in with your email and password first, then you can link your accounts by going to your Account Settings.',
        url: '',
    },
    ACCOUNT_CANNOT_BE_CREATED: {
        text: 'Account with this email could not be created.',
        url: '',
    },
};

export const restrictionMessages = [
    {
        keywords: ['rate', 'limit', 'reached'],
        text: 'You have exceeded the number of attempts for your request. Please try again in a few minutes.',
        url: '',
        title: 'Request limit reached',
    },
];
